import { FragmentType, useFragment } from '@/gql'
import { FieldableFormCustomFieldValueFragment } from '@/components/Fieldable/graphql/fragments'
import { CustomFieldType, CustomFieldTypeValueInput } from '@/gql/graphql'
import { CustomFieldTypeGqlToInput } from '@/components/Fields/utils/CustomFieldUtils'

export const mapCustomFieldValueToCustomFieldValueInput = (
  customFieldValues: FragmentType<typeof FieldableFormCustomFieldValueFragment>[],
): CustomFieldTypeValueInput[] => {
  const customFieldValuesTyped = useFragment(
    FieldableFormCustomFieldValueFragment,
    customFieldValues,
  )

  return customFieldValuesTyped.map((customFieldValue) => {
    const { fieldType } = customFieldValue.customField
    const fieldValue = {
      [CustomFieldType.SingleSelect]: customFieldValue.customFieldOption?.id,
      [CustomFieldType.FreeText]: customFieldValue.content,
    }

    return {
      [CustomFieldTypeGqlToInput[fieldType]]: {
        id: customFieldValue.customField.id,
        value: fieldValue[fieldType],
      },
    }
  })
}
